import { actions } from './data'

// Backend
export function saveSettings(settings) {
    return actions.backend.saveSettings(settings)
}

export function setDownloadEverything(downloadEverything) {
    return actions.backend.setDownloadEverything(downloadEverything)
}

export function setRunClientsWithLogging(runWithLogging) {
    return actions.backend.setRunClientsWithLogging(runWithLogging)
}

export function setRunClientsWithDx9(runWithDx9) {
    return actions.backend.setRunClientsWithDx9(runWithDx9)
}

export function setShouldMinimizeToTray(shouldMinimize) {
    return actions.backend.setShouldMinimizeToTray(shouldMinimize)
}

export function setLanguage(language) {
    return actions.backend.setLanguage(language)
}

export function setTestServers(testServers) {
    return actions.backend.setTestServers(testServers)
}

// UI
export function saveUiSettings(uiSettings) {
    return actions.ui.saveUiSettings(uiSettings)
}

export function setLaunchDelay(delay) {
    return actions.ui.setLaunchDelay(delay)
}

export function setAutoLaunchOnLogin(autoLaunch) {
    return actions.ui.setAutoLaunchOnLogin(autoLaunch)
}

export function setAutoLaunchOnStartup(autoLaunch) {
    return actions.ui.setAutoLaunchOnStartup(autoLaunch)
}

export function setLayout(layout) {
    return actions.ui.setLayout(layout)
}

// Localized
export function setLocale(language) {
    return actions.localized.setLocale(language)
}

// Servers
export function setServers(servers) {
    return actions.servers.setServers(servers)
}

// Display
export function increaseCounter() {
    return actions.display.increaseCounter()
}

export function clearCounter() {
    return actions.display.clearCounter()
}

// Exposed
export function forgetAllPinnedUsers() {
    return actions.forgetAllPinnedUsers()
}

export function uiSettingsChanged(newUiSettings) {
    return actions.uiSettingsChanged(newUiSettings)
}

export function settingsChanged(newSettings) {
    return actions.settingsChanged(newSettings)
}

export function languageChanged(prevLocale, newLocale) {
    return actions.languageChanged(prevLocale, newLocale)
}



// WEBPACK FOOTER //
// ./src/features/Settings/actions.js